/**
 * Account Page Theme
 * Styling configuration for Account page
 */

const baseStyle = {
  base: {
    // Container styling cho Account page
    maxWidth: '100%',
    paddingTop: 0, // Responsive padding top
    width: '100%',
  },
  contentContainer: {
    // Container styling cho Account page
    maxWidth: '1440px',
    mx: 'auto',
    paddingBottom: '40px',
    paddingTop: {base: '16px', lg: '64px'},
    paddingX: {base: '20px', lg: '80px'},
    position: 'relative',
  },
  heroContainer: {
    position: 'relative',
    sx: {
      '.hero-content-wrapper': {
        display: 'none',
      },
    },
  },
  heroContent: {
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    maxWidth: '1440px',
    mx: 'auto',
    paddingX: {base: '20px', lg: '80px'},
  },
  heroContentWrapper: {
    bottom: 0,
    left: 0,
    paddingBottom: {base: '25px', lg: '64px'},
    position: 'absolute',
    right: 0,
    zIndex: 1,
  },
  heroGreeting: {
    fontSize: {base: '16px', lg: '32px'},
    fontWeight: '500',
  },
  heroGreetingUserName: {
    fontSize: {base: '40px', lg: '60px'},
    fontWeight: '500',
    letterSpacing: '-0.6px',
    lineHeight: '120%',
  },
};

const Account = {
  baseStyle,
  parts: ['base', 'contentContainer', 'heroContainer', 'heroContentWrapper', 'heroContent', 'heroGreeting', 'heroGreetingUserName'],
};

export default Account;
